import { useApiQuery } from "app/modules/api-client";
import type { IFlattenedCategory } from "app/common/services/categoryService.types";
import type { IIndustryDataAvailabilityState } from "app/pages/digital-marketing/ad-intelligence/common/data-availability/industryDataAvailability";
import { INDUSTRY_ENDPOINT_MIN_DATE } from "app/pages/digital-marketing/ad-intelligence/common/data-availability/industryDataAvailability";

import type { ICountriesResponse } from "../../hooks/useCountries";
import { useIndustryAvailabilityParams } from "../useIndustryAvailabilityParams";

interface IUseIndustrySpendRankResult {
    data?: ICountriesResponse;
    isLoading: boolean;
    isError: boolean;
    availability: IIndustryDataAvailabilityState;
}

export const useIndustrySpendRank = (category: IFlattenedCategory): IUseIndustrySpendRankResult => {
    const { params, availability } = useIndustryAvailabilityParams(
        category,
        INDUSTRY_ENDPOINT_MIN_DATE.adintelligenceIndustrySpendRankList,
    );

    const { data, isLoading, isFetching, isError } = useApiQuery(
        {
            tag: "AdIntelligenceMarketingAssets",
            methodName: "adintelligenceIndustrySpendRankList",
            options: { enabled: !availability.isFullyUnavailable },
        },
        params,
    );

    return {
        data,
        isLoading: isLoading || isFetching,
        isError,
        availability,
    };
};
